import axios from 'axios';
import constants from 'config/constants';
import { getReport } from './reports';

// Plain (non-thunk) axios calls, same rationale as actions/admin/inventory.js - this module has
// no redux slice of its own, screens call these directly and keep their own local state.
const BASE = constants.API_BASE_URL;

const APIS = {
  summary: '/api/finance/report',
  transactions: '/api/finance/report/transactions',
  transactionsPdf: '/api/finance/report/transactions/pdf',
};

// constants.makeParams sends every key it's given, undefined/null included (as the literal
// string "undefined"), so strip those before building the query string - most of these params
// are conditional on which periodType is selected and are genuinely absent the rest of the time.
const cleanParams = params =>
  Object.fromEntries(
    Object.entries(params).filter(([, value]) => value !== undefined && value !== null && value !== '')
  );

// GET /api/finance/report?schoolId=&periodType=MONTHLY|QUARTERLY|HALF_YEARLY|YEARLY|CUSTOM&...
// No WEEKLY here - the backend controller for this endpoint has no `week` param at all, only the
// transactions endpoint below does.
export const fetchFinanceSummaryApi = ({ token, ...params }) =>
  axios.get(`${BASE}${APIS.summary}${constants.makeParams(cleanParams(params))}`, constants.setHeader(token));

// GET /api/finance/report/transactions?schoolId=&periodType=WEEKLY|MONTHLY|QUARTERLY|HALF_YEARLY|YEARLY|CUSTOM&...
export const fetchFinanceTransactionsApi = ({ token, ...params }) =>
  axios.get(`${BASE}${APIS.transactions}${constants.makeParams(cleanParams(params))}`, constants.setHeader(token));

// GET /api/finance/report/transactions/pdf?schoolId=&periodType=DAILY|MONTHLY&... - Day and Month
// only, that's all the backend's PdfReportPeriodType enum supports (no Weekly PDF yet). Reuses the
// app's existing global PDF-preview modal (ViewReportModal, opened by the same getReport() action
// every other "view PDF report" flow in this app already dispatches) instead of building a new one.
export const fetchFinanceTransactionsPdfService =
  ({ token, reportName, ...params }) =>
  async dispatch => {
    const res = await axios({
      method: 'GET',
      url: `${BASE}${APIS.transactionsPdf}${constants.makeParams(cleanParams(params))}`,
      headers: constants.setHeader(token).headers,
      responseType: 'arraybuffer',
    });
    dispatch(getReport({ fileData: res.data, headingName: reportName }));
  };

// GET /api/course-reports/fees/course/{courseId}?batchId=&pendingOnly= -> one row per student of the class with what the
// fee structure asks, what was paid, refunded and is left (paymentStatus PAID | PARTIAL | UNPAID) and the guardian's contact.
export const fetchClassFeeReportApi = ({ token, courseId, ...params }) =>
  axios.get(
    `${BASE}/api/course-reports/fees/course/${courseId}${constants.makeParams(cleanParams(params))}`,
    constants.setHeader(token)
  );
